import React from "react";
import { Card, Typography, Row, Col, Tag, Space, Tooltip } from "antd";
import {
  ExclamationCircleOutlined, UsergroupAddOutlined, MailOutlined, UserOutlined,
} from "@ant-design/icons";
import { useQuery } from "@apollo/client";
import { GET_ACCESS_HEALTH_SUMMARY } from "../../../Queries/clientSlots";
import SlotsPanel from "./SlotsPanel.jsx";

const { Title, Text } = Typography;

export default function AccessSlotsPage() {
  const { data, loading, refetch } = useQuery(GET_ACCESS_HEALTH_SUMMARY, {
    fetchPolicy: "cache-and-network",
  });
  const h = data?.getAccessHealthSummary;

  return (
    <div style={{ padding: 24 }}>
      <div style={{ marginBottom: 16 }}>
        <Title level={3} style={{ margin: 0 }}>Access Management</Title>
        <Text type="secondary">
          One source of truth across Client, Employee, and this page.
          Edit a slot anywhere — all three views update.
        </Text>
      </div>

      {/* Things to fix — always at the top, actionable */}
      <Card
        style={{ marginBottom: 16 }}
        title={<span><ExclamationCircleOutlined style={{ color: "#faad14" }} /> Things to fix</span>}
        loading={loading && !h}
        extra={<a onClick={() => refetch()}>Refresh</a>}
      >
        <Row gutter={[12, 12]}>
          <Col xs={24} sm={12} md={6}>
            <FixCard
              label="Clients with no slots"
              count={h?.activeClientsWithoutSlots || 0}
              color="#faad14"
              icon={<UsergroupAddOutlined />}
              sample={h?.sampleClientsWithoutSlots}
              hint="Active clients can't receive requests until they have at least one slot."
            />
          </Col>
          <Col xs={24} sm={12} md={6}>
            <FixCard
              label="Slots with no email"
              count={h?.slotsWithoutEmail || 0}
              color="#fa8c16"
              icon={<MailOutlined />}
              sample={h?.sampleSlotsWithoutEmail}
              hint="Slots without an assigned email don't gate access yet."
            />
          </Col>
          <Col xs={24} sm={12} md={6}>
            <FixCard
              label="Slots with no members"
              count={h?.slotsWithoutMembers || 0}
              color="#fa541c"
              icon={<UserOutlined />}
              sample={h?.sampleSlotsWithoutMembers}
              hint="Empty slots have no one to handle their requests."
            />
          </Col>
          <Col xs={24} sm={12} md={6}>
            <FixCard
              label="Employees with no slots"
              count={h?.activeEmployeesWithoutSlots || 0}
              color="#cf1322"
              icon={<UserOutlined />}
              sample={h?.sampleEmployeesWithoutSlots}
              hint="Active employees that can't see any requests yet."
            />
          </Col>
        </Row>
      </Card>

      {/* The slot editor — cross-cutting view */}
      <SlotsPanel scope="all" />
    </div>
  );
}

function FixCard({ label, count, color, icon, sample, hint }) {
  const top = (sample || []).slice(0, 3);
  return (
    <Tooltip
      title={
        <div>
          <div style={{ marginBottom: 6 }}>{hint}</div>
          {top.length > 0 && (
            <div style={{ fontSize: 11 }}>
              {top.map((s) => <div key={s}>• {s}</div>)}
              {sample && sample.length > 3 && <div>… and {sample.length - 3} more</div>}
            </div>
          )}
        </div>
      }
    >
      <div
        style={{
          padding: 14,
          borderRadius: 8,
          background: count > 0 ? `${color}11` : "#fafafa",
          border: `1px solid ${count > 0 ? color + "55" : "#f0f0f0"}`,
          cursor: count > 0 ? "help" : "default",
        }}
      >
        <Space>
          <span style={{ color, fontSize: 18 }}>{icon}</span>
          <div>
            <div style={{ fontSize: 22, fontWeight: 700, color: count > 0 ? color : "#8c8c8c" }}>
              {count}
            </div>
            <Text type="secondary" style={{ fontSize: 12 }}>{label}</Text>
          </div>
        </Space>
      </div>
    </Tooltip>
  );
}
